var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem2B(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      enableBackground: "new 0 0 750 289"
    },
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M750 0H0v289.4h750V0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.7 117.8c-9.7-3-16.4-6.8-20.2-11.3v98.4c3.7 4.6 10.4 8.3 20.2 11.3z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459 106.9c-2.6 3.1-6.6 5.8-12.1 8.1v98.4c5.5-2.3 9.5-5 12.1-8.1z",
    style: {
      fill: "#7f7f7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.8 120.3c-2.7-.5-5.4-1.1-8.1-1.8v98.4c2.7.7 5.4 1.3 8.1 1.8z",
    style: {
      fill: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.9 121.2c-1.2-.1-2.4-.2-3.6-.4v98.4c1.2.2 2.4.3 3.6.4z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m684.9 101.5-25.7 19.2v98.4l25.7-19.4z",
    style: {
      fill: "#bfbfbf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m605.4 121.6-28.1-18.9v98.4l28.1 18.7z",
    style: {
      fill: "#1a1a1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m684.9 101.6-28.2-18.7-53.8.5-25.5 19.2 28.1 18.9 53.8-.7z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m659.3 120.8-53.8.7v98.2l53.8-.5z",
    style: {
      fill: "#7f7f7f"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m657.2 82.2-.2-.2-54.5.5-.2.2-25.5 19.3-.4.4v99.3l.4.2 28.1 18.7.4.2 54.3-.5.2-.2 25.7-19.4.4-.2v-99.4l-.4-.2-28.3-18.7m-.8 1.6 27.6 18.3v97.3l-25.1 19-53.3.5-27.4-18.2v-97.6l24.9-18.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M408.7 121.9h.8c32.7-1.6 50.2-9.2 52.4-22.7-3.7-13.1-21.6-20.2-53.6-21.4h-1.6c-32.8 1.6-50.3 9.2-52.4 22.7 3.8 13.2 21.9 20.3 54.4 21.4z",
    style: {
      fill: "#fff"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M462.8 100v-.7c-.3-3.4-1.9-6.4-4.9-9-4.6-4.1-11.2-7.3-20-9.5-8.8-2.4-18.8-3.7-29.9-3.8h-1.4c-15.1.3-27.6 2.6-37.6 6.8-4.7 2-8.5 4.3-11.3 7-2.9 2.8-4.3 5.8-4.3 9v.7c.3 3.3 1.9 6.3 4.9 9 4.6 4 11.2 7.2 20 9.5 8.8 2.5 18.8 3.7 29.9 3.8h1.4c15.1-.3 27.5-2.6 37.4-6.8 4.9-2 8.8-4.3 11.5-7 2.8-2.7 4.2-5.7 4.3-9m-17.5-15.1c4.7 2 8.5 4.3 11.3 6.7 2.7 2.6 4.1 5.2 4.3 7.7v.7c0 2.6-1.3 5.2-3.8 7.7-4 3.8-10.1 6.9-18.5 9.4-8.3 2.4-18.1 3.7-29.1 4h-1.4c-14.9-.1-27.3-2.2-37.2-6.3-4.7-1.9-8.5-4-11.3-6.5-2.7-2.5-4.1-5.2-4.3-7.9v-.5c0-2.6 1.3-5.2 3.8-7.7 3.9-3.7 10.1-6.8 18.5-9.4 8.3-2.4 18-3.7 29.1-4h1.4c14.8.2 27.2 2.2 37.2 6.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m79.5 101.7 78.3 30.2 74.1-32-78.3-30.2z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.9 198.2V99.8l-74.1 32V230z",
    style: {
      fill: "#bfbfbf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.8 131.7-78.3-30.2v98.2l78.3 30.2z",
    style: {
      fill: "#333"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m232.8 99.3-.7-.2L154 68.9l-.4-.2-74.5 32-.5.3v99.7l78.8 30.4.4.2 74.5-32.2.5-.2V99.3m-1.8 1.3v97.1l-73.2 31.6-77.4-29.9v-97.3l73.2-31.4zm231.8-1.3c0-.6-.3-.9-.9-.9-.6 0-.9.3-.9.9v.7c0 2.6-1.3 5.2-3.8 7.7-4 3.7-10.1 6.8-18.5 9.4-8.3 2.4-18.1 3.7-29.1 4h-1.4c-14.9-.1-27.3-2.2-37.2-6.3-4.7-1.9-8.5-4.1-11.3-6.5-2.7-2.6-4.1-5.2-4.3-7.9-.2-.4-.5-.7-1.1-.7-.4 0-.7.3-.7.9V199c.3 3.2 1.9 6.2 4.9 9 4.6 4 11.2 7.1 20 9.5 8.8 2.4 18.8 3.7 29.9 3.8h1.4c15.1-.3 27.5-2.6 37.4-6.8 4.9-2 8.8-4.3 11.5-7 2.8-2.7 4.3-5.8 4.3-9.2v-99m-4.5 9.8c1-1 1.9-2.1 2.5-3.1v92.3c0 2.8-1.3 5.4-3.8 7.9-4 3.7-10.1 6.8-18.5 9.4-8.3 2.4-18.1 3.7-29.1 4h-1.4c-14.9-.2-27.3-2.3-37.2-6.3-4.7-1.9-8.5-4.1-11.3-6.5-2.7-2.6-4.1-5.2-4.3-7.9v-93c.8 1.3 1.8 2.5 3.1 3.7 4.6 4 11.2 7.1 20 9.5 8.8 2.4 18.8 3.7 29.9 3.8h1.4c15.1-.3 27.5-2.6 37.4-6.8 4.7-2 8.5-4.3 11.3-7z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M163.4 93c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7 0 3.4 1.2 6.3 3.6 8.7 2.4 2.4 5.3 3.6 8.7 3.6 3.4 0 6.2-1.2 8.6-3.6 2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    style: {
      fill: "#369",
      fillOpacity: 0.502
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "scale(.99905 1.00095)",
    x: 151.011,
    y: 106.467,
    style: {
      strokeWidth: 0.99905,
      fontSize: "11.4815px",
      fontFamily: "'ArialMT'",
      fill: "#fff"
    }
  }, "     1  "), /*#__PURE__*/React.createElement("path", {
    d: "M415.3 93c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7 0 3.4 1.2 6.3 3.6 8.7 2.4 2.4 5.3 3.6 8.7 3.6 3.4 0 6.2-1.2 8.6-3.6 2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    style: {
      fill: "#369",
      fillOpacity: 0.502
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "scale(.99905 1.00095)",
    x: 403.151,
    y: 106.467,
    style: {
      strokeWidth: 0.99905,
      fontSize: "11.4815px",
      fontFamily: "'ArialMT'",
      fill: "#fff"
    }
  }, "     2  "), /*#__PURE__*/React.createElement("path", {
    d: "M641.4 93c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7 0 3.4 1.2 6.3 3.6 8.7 2.4 2.4 5.3 3.6 8.7 3.6 3.4 0 6.2-1.2 8.6-3.6 2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    style: {
      fill: "#369",
      fillOpacity: 0.502
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "scale(.99905 1.00095)",
    x: 629.515,
    y: 106.467,
    style: {
      strokeWidth: 0.99905,
      fontSize: "11.4815px",
      fontFamily: "'ArialMT'",
      fill: "#fff"
    }
  }, "     3  "));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem2B);
export default __webpack_public_path__ + "static/media/item2b.47058a07c39d0292ea04791a14828e3e.svg";
export { ForwardRef as ReactComponent };